
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/comunicacao-venda",
      function () {
        return require("private-next-pages/comunicacao-venda/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/comunicacao-venda"])
      });
    }
  